if (!window.Maximize.loadedScript.includes('estimate-shipping-rate.js')) {
  window.Maximize.loadedScript.push('estimate-shipping-rate.js');
  
  const _registerEstimateShipping = () => {
    Alpine.data("xEstimateShipping", (el, single, multiple, noRatesText) => ({
        isOpen: false,
        countryEl: el.querySelector(".country-select"),
        provinceEl: el.querySelector(".province-select"),
        provinceContainer: el.querySelector(".province-container"),
        zip: el.querySelector(".zip-input"),
        rates: el.querySelector(".rates"),
        errors: el.querySelector(".errors"),
        loadingShipping: false,
        rates_heading: "",
        rates_text: "",
        errors_message: "",
        cachedData: [],
        cachedResponse: [],
        load() {
          this.setSelectedOption(this.countryEl, this.countryEl.dataset.default);

          if (this.provinceEl.dataset.default && this.provinceEl.options.length > 0) {
            this.setSelectedOption(this.provinceEl, this.provinceEl.dataset.default);
          }

          this.handleCountryChange();
          this.countryEl.addEventListener("change", this.handleCountryChange.bind(this));
        },

        handleCountryChange() {
          const selectedOption = this.countryEl.options[this.countryEl.selectedIndex];
          const provinces = JSON.parse(selectedOption.dataset.provinces);

          Array.from(this.provinceEl.options).forEach((option) => option.remove());

          if (provinces && provinces.length === 0) {
            this.provinceContainer.hidden = true;
          } else {
            provinces.forEach((province) => {
              const option = document.createElement("option");
              [option.value, option.innerHTML] = province;
              this.provinceEl.appendChild(option);
            });

            this.provinceContainer.hidden = false;
          }
        },

        setSelectedOption(selector, value) {
          Array.from(selector.options).forEach((option, index) => {
            if (option.value === value || option.innerHTML === value) {
              selector.selectedIndex = index;
            }
          });
        },

        async submit(e) {
          e?.preventDefault();

          this.errors.classList.add("hidden");
          this.rates.classList.add("hidden");

          const params = `shipping_address[zip]=${this.zip.value}&shipping_address[country]=${this.countryEl.value}&shipping_address[province]=${this.provinceEl.value}`;

          if (this.cachedData[params]) {
            if (this.cachedResponse[params]) {
              this.showRates(this.cachedData[params]);
            } else {
              this.showErrors(this.cachedData[params]);
            }
            return true;
          }

          this.loadingShipping = true;
          try {
            const response = await fetch(`${Shopify.routes.root}cart/shipping_rates.json?${params}`);
            const data = await response.json();

            if (response.ok) {
              this.showRates(data);
            } else {
              this.showErrors(data);
            }
            this.cachedResponse[params] = response.ok;
            this.cachedData[params] = data;
          } catch (error) {
            console.error(error);
          } finally {
            this.loadingShipping = false;
          }
        },

        showRates(data) {
          const headingEl = this.rates.querySelector(".rates-heading");

          if (data.shipping_rates && data.shipping_rates.length) {
            this.rates_heading = data.shipping_rates.length === 1 ? single : multiple;
            let rates = "";

            data.shipping_rates.forEach((rate) => {
              const formattedRate = rate.price + rate.currency;
              rates += `<li class="pt-2">${rate.name}: ${formattedRate}</li>`;
            });

            headingEl.classList.remove("hidden");
            this.rates.classList.add("success-message");
            if (this.rates.classList.contains("flash-message")) {
              this.rates.classList.remove("error-message");
            } else {
              this.rates.classList.remove("color-text-[rgba(var(--error-message-color))]");
            }
            this.rates_text = `<ul class="list-disc`;
            if (window.Maximize.rtl) {
              this.rates_text += ` pr-4">${rates}</ul>`;
            } else {
              this.rates_text += ` pl-4">${rates}</ul>`;
            }
          } else {
            headingEl.classList.add("hidden");
            this.rates.classList.remove("success-message");
            if (this.rates.classList.contains("flash-message")) {
              this.rates.classList.add("error-message");
            } else {
              this.rates.classList.add("color-text-[rgba(var(--error-message-color))]");
            }
            this.rates_text = `<p class="no-rate">${noRatesText}</p>`;
          }

          this.rates.classList.remove("hidden");
        },

        showErrors(data) {
          let errors = "";
          Object.keys(data).forEach((key) => {
            errors += `<li>${data[key]}</li>`;
          });

          this.errors_message = `<ul>${errors}</ul>`;
          this.errors.classList.remove("hidden");
        },
      }));

      Alpine.store("xPopupShipping", {
        open: false,
      });
  };

  if (window.Alpine) {
    _registerEstimateShipping();
  } else {
    document.addEventListener("alpine:init", _registerEstimateShipping);
  }

  class EstimateShippingRateDrawer extends HTMLElement {
    connectedCallback() {
      this._single = this.dataset.single;
      this._multiple = this.dataset.multiple;
      this._noRates = this.dataset.noRates;

      this._countryEl = this.querySelector(".country-select");
      this._provinceEl = this.querySelector(".province-select");
      this._provinceContainer = this.querySelector(".province-container");
      this._zipEl = this.querySelector(".zip-input");
      this._ratesEl = this.querySelector(".rates");
      this._errorsEl = this.querySelector(".errors");

      this._cachedData = {};
      this._cachedResponse = {};

      this._load();
      this._countryEl.addEventListener("change", this._handleCountryChange.bind(this));

      this.addEventListener("click", (e) => {
        if (e.target.closest('[data-action="submit"]')) this.submit(e);
      });
    }

    _load() {
      this._setSelectedOption(this._countryEl, this._countryEl.dataset.default);
      if (this._provinceEl.dataset.default && this._provinceEl.options.length > 0) {
        this._setSelectedOption(this._provinceEl, this._provinceEl.dataset.default);
      }
      this._handleCountryChange();
    }

    _handleCountryChange() {
      const selectedOption = this._countryEl.options[this._countryEl.selectedIndex];
      const provinces = JSON.parse(selectedOption.dataset.provinces);

      Array.from(this._provinceEl.options).forEach((opt) => opt.remove());

      if (!provinces || provinces.length === 0) {
        this._provinceContainer.hidden = true;
      } else {
        provinces.forEach(([value, label]) => {
          const option = document.createElement("option");
          option.value = value;
          option.innerHTML = label;
          this._provinceEl.appendChild(option);
        });
        this._provinceContainer.hidden = false;
      }
    }

    _setSelectedOption(selector, value) {
      Array.from(selector.options).forEach((option, index) => {
        if (option.value === value || option.innerHTML === value) {
          selector.selectedIndex = index;
        }
      });
    }

    _setLoading(val) {
      this.querySelector(".button-label")?.classList.toggle("opacity-0", val);
      this.querySelector(".spinner")?.classList.toggle("hidden", !val);
    }

    async submit(e) {
      e?.preventDefault();

      this._ratesEl.classList.add("hidden");
      this._errorsEl.classList.add("hidden");

      const params = `shipping_address[zip]=${this._zipEl.value}&shipping_address[country]=${this._countryEl.value}&shipping_address[province]=${this._provinceEl.value}`;

      if (this._cachedData[params]) {
        if (this._cachedResponse[params]) {
          this._showRates(this._cachedData[params]);
        } else {
          this._showErrors(this._cachedData[params]);
        }
        return;
      }

      this._setLoading(true);
      try {
        const response = await fetch(`${Shopify.routes.root}cart/shipping_rates.json?${params}`);
        const data = await response.json();

        if (response.ok) {
          this._showRates(data);
        } else {
          this._showErrors(data);
        }
        this._cachedResponse[params] = response.ok;
        this._cachedData[params] = data;
      } catch (error) {
        console.error(error);
      } finally {
        this._setLoading(false);
      }
    }

    _showRates(data) {
      const headingEl = this._ratesEl.querySelector(".rates-heading");
      const textEl = this._ratesEl.querySelector(".rates-text");

      if (data.shipping_rates && data.shipping_rates.length) {
        headingEl.textContent = data.shipping_rates.length === 1 ? this._single : this._multiple;
        headingEl.classList.remove("hidden");
        this._ratesEl.classList.add("success-message");
        this._ratesEl.classList.remove("error-message");

        const dir = window.Maximize.rtl ? "pr-4" : "pl-4";
        const items = data.shipping_rates.map((rate) => `<li class="pt-2">${rate.name}: ${rate.price + rate.currency}</li>`).join("");
        textEl.innerHTML = `<ul class="list-disc ${dir}">${items}</ul>`;
      } else {
        headingEl.classList.add("hidden");
        this._ratesEl.classList.remove("success-message");
        this._ratesEl.classList.add("error-message");
        textEl.innerHTML = `<p class="no-rate">${this._noRates}</p>`;
      }

      this._ratesEl.classList.remove("hidden");
    }

    _showErrors(data) {
      const errors = Object.keys(data)
        .map((key) => `<li>${data[key]}</li>`)
        .join("");
      this._errorsEl.querySelector(".errors-text").innerHTML = `<ul>${errors}</ul>`;
      this._errorsEl.classList.remove("hidden");
    }
  }

  if (!customElements.get("estimate-shipping-rate")) {
    customElements.define("estimate-shipping-rate", EstimateShippingRateDrawer);
  }
}

/**
 * [ECOMHARD] PDP shipping estimator.
 * Keeps the legacy cart estimator unchanged and renders PDP results as a table.
 */
class EcomhardShippingRatePdp extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this._form = this.querySelector(".ecomhard-shipping-rate-pdp__form");
    this._zipEl = this.querySelector(".ecomhard-shipping-rate-pdp__input");
    this._countryEl = this.querySelector(".ecomhard-shipping-rate-pdp__country");
    this._resultsEl = this.querySelector(".ecomhard-shipping-rate-pdp__results");
    this._resultTitleEl = this.querySelector(".ecomhard-shipping-rate-pdp__result-title");
    this._ratesBodyEl = this.querySelector(".ecomhard-shipping-rate-pdp__rates-body");
    this._noRatesEl = this.querySelector(".ecomhard-shipping-rate-pdp__no-rates");
    this._errorEl = this.querySelector(".ecomhard-shipping-rate-pdp__error");
    this._clearButtonEl = this.querySelector('[data-action="clear"]');
    this._cache = new Map();
    this._zipCache = new Map();

    this._setCountry();
    this._formatZip();

    this._form?.addEventListener("submit", this._handleSubmit.bind(this));
    this._zipEl?.addEventListener("input", this._formatZip.bind(this));
    this._clearButtonEl?.addEventListener("click", this._clear.bind(this));
  }

  _setCountry() {
    if (!this._countryEl) return;

    const defaultCountry = this.dataset.country;
    if (!defaultCountry) return;

    const normalizedDefault = defaultCountry.trim().toLocaleLowerCase();
    const option = Array.from(this._countryEl.options).find((item) => {
      const value = (item.value || "").trim().toLocaleLowerCase();
      const label = (item.textContent || "").trim().toLocaleLowerCase();
      return value === normalizedDefault || label === normalizedDefault;
    });

    if (option) this._countryEl.value = option.value;
  }

  _formatZip() {
    if (!this._zipEl) return;

    const digits = this._zipEl.value.replace(/\D/g, "").slice(0, 8);
    this._zipEl.value = digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
  }

  async _resolveProvince(zip, country) {
    const normalizedCountry = String(country || "").trim().toLocaleLowerCase();
    const isBrazil = ["brazil", "brasil"].includes(normalizedCountry);

    // O endpoint de frete da Shopify exige o estado para CEPs brasileiros.
    // Como o layout da PDP possui somente o campo de CEP, identificamos a UF automaticamente.
    if (!isBrazil) return "";

    if (this._zipCache.has(zip)) return this._zipCache.get(zip);

    try {
      const response = await fetch(`https://viacep.com.br/ws/${zip}/json/`, {
        headers: { Accept: "application/json" }
      });
      const address = await response.json().catch(() => ({}));

      if (!response.ok || address?.erro || !address?.uf) {
        throw new Error("Não foi possível identificar o estado para este CEP.");
      }

      const province = this._getShopifyProvinceForUf(address.uf);
      this._zipCache.set(zip, province);
      return province;
    } catch (error) {
      throw new Error(error?.message || "Não foi possível identificar o estado para este CEP.");
    }
  }

  _getShopifyProvinceForUf(uf) {
    const stateNames = {
      AC: "Acre",
      AL: "Alagoas",
      AP: "Amapá",
      AM: "Amazonas",
      BA: "Bahia",
      CE: "Ceará",
      DF: "Distrito Federal",
      ES: "Espírito Santo",
      GO: "Goiás",
      MA: "Maranhão",
      MT: "Mato Grosso",
      MS: "Mato Grosso do Sul",
      MG: "Minas Gerais",
      PA: "Pará",
      PB: "Paraíba",
      PR: "Paraná",
      PE: "Pernambuco",
      PI: "Piauí",
      RJ: "Rio de Janeiro",
      RN: "Rio Grande do Norte",
      RS: "Rio Grande do Sul",
      RO: "Rondônia",
      RR: "Roraima",
      SC: "Santa Catarina",
      SP: "São Paulo",
      SE: "Sergipe",
      TO: "Tocantins"
    };

    const normalize = (value) => String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toLocaleLowerCase();

    const candidates = [uf, stateNames[String(uf || "").toUpperCase()]].filter(Boolean).map(normalize);
    const selectedCountry = this._countryEl?.selectedOptions?.[0];

    try {
      const provinces = JSON.parse(selectedCountry?.dataset?.provinces || "[]");
      const match = provinces.find((province) => {
        const [value, label] = Array.isArray(province) ? province : [province, province];
        return candidates.includes(normalize(value)) || candidates.includes(normalize(label));
      });

      if (match) return Array.isArray(match) ? match[0] : match;
    } catch (error) {
      console.warn("[ECOMHARD] Não foi possível ler os estados configurados na Shopify.", error);
    }

    // Fallback para lojas cujo country_option_tags não retorna a lista de estados no HTML.
    return stateNames[String(uf || "").toUpperCase()] || uf;
  }

  async _handleSubmit(event) {
    event.preventDefault();

    const zip = (this._zipEl?.value || "").replace(/\D/g, "");
    if (zip.length !== 8) {
      this._showError(this.dataset.invalidZipMessage || "Digite um CEP válido.");
      this._zipEl?.focus();
      return;
    }

    this._hideFeedback();
    this._setLoading(true);

    try {
      const country = this._countryEl?.value || this.dataset.country || "Brazil";
      const province = await this._resolveProvince(zip, country);
      const params = new URLSearchParams({
        "shipping_address[zip]": zip,
        "shipping_address[country]": country,
        "shipping_address[province]": province
      });
      const cacheKey = params.toString();
      let data;

      if (this._cache.has(cacheKey)) {
        data = this._cache.get(cacheKey);
      } else {
        const response = await fetch(`${Shopify.routes.root}cart/shipping_rates.json?${params.toString()}`, {
          headers: { Accept: "application/json" }
        });

        data = await response.json().catch(() => ({}));

        if (!response.ok) {
          throw new Error(this._getApiError(data));
        }

        this._cache.set(cacheKey, data);
      }

      this._showRates(data);
    } catch (error) {
      console.error("[ECOMHARD] Não foi possível calcular o frete.", error);
      this._showError(error?.message || this.dataset.errorMessage || "Não foi possível calcular o frete. Revise o CEP e tente novamente.");
    } finally {
      this._setLoading(false);
    }
  }

  _clear() {
    if (this.classList.contains("is-loading")) return;

    this._hideFeedback();
    if (this._zipEl) {
      this._zipEl.value = "";
      this._zipEl.focus();
    }
  }

  _setLoading(isLoading) {
    this.classList.toggle("is-loading", isLoading);
    this.querySelector(".ecomhard-shipping-rate-pdp__overlay")?.setAttribute("aria-hidden", String(!isLoading));
  }

  _hideFeedback() {
    this._resultsEl?.setAttribute("hidden", "");
    this._errorEl?.setAttribute("hidden", "");
    this._noRatesEl?.setAttribute("hidden", "");
    if (this._ratesBodyEl) this._ratesBodyEl.innerHTML = "";
  }

  _showRates(data) {
    const rates = Array.isArray(data?.shipping_rates) ? data.shipping_rates : [];

    this._resultsEl?.removeAttribute("hidden");
    if (this._resultTitleEl) {
      this._resultTitleEl.textContent = this.dataset.resultTitle || "Opções de entrega";
    }

    if (!rates.length) {
      this._ratesBodyEl?.closest("table")?.setAttribute("hidden", "");
      if (this._noRatesEl) {
        this._noRatesEl.textContent = this.dataset.noRates || "Não encontramos opções de entrega para este CEP.";
        this._noRatesEl.removeAttribute("hidden");
      }
      return;
    }

    this._ratesBodyEl?.closest("table")?.removeAttribute("hidden");
    this._noRatesEl?.setAttribute("hidden", "");

    const fragment = document.createDocumentFragment();

    rates.forEach((rate) => {
      const row = document.createElement("tr");
      const infoCell = document.createElement("td");
      const priceCell = document.createElement("td");
      const info = document.createElement("div");
      const name = document.createElement("strong");
      const deadline = document.createElement("span");

      info.className = "ecomhard-shipping-rate-pdp__rate-info";
      name.className = "ecomhard-shipping-rate-pdp__rate-name";
      deadline.className = "ecomhard-shipping-rate-pdp__rate-deadline";
      priceCell.className = "ecomhard-shipping-rate-pdp__rate-price";

      name.textContent = rate.presentment_name || rate.name || "Entrega";
      deadline.textContent = this._getDeadline(rate);
      priceCell.textContent = this._formatPrice(rate);

      info.append(name, deadline);
      infoCell.appendChild(info);
      row.append(infoCell, priceCell);
      fragment.appendChild(row);
    });

    this._ratesBodyEl?.appendChild(fragment);
  }

  _showError(message) {
    this._resultsEl?.setAttribute("hidden", "");
    if (this._errorEl) {
      this._errorEl.textContent = message || this.dataset.errorMessage || "Não foi possível calcular o frete. Revise o CEP e tente novamente.";
      this._errorEl.removeAttribute("hidden");
    }
  }

  _getDeadline(rate) {
    const prefix = this.dataset.deadlinePrefix || "Prazo:";
    const range = Array.isArray(rate?.delivery_range) ? rate.delivery_range.filter(Boolean) : [];

    if (range.length >= 2) {
      return `${prefix} ${this.dataset.deliveryBetween || "Entrega entre"} ${this._formatDate(range[0])} e ${this._formatDate(range[1])}`;
    }

    if (rate?.delivery_date) {
      return `${prefix} ${this.dataset.deliveryBy || "Entrega até"} ${this._formatDate(rate.delivery_date)}`;
    }

    if (Array.isArray(rate?.delivery_days) && rate.delivery_days.length) {
      const [minDays, maxDays] = rate.delivery_days;
      const days = maxDays && maxDays !== minDays ? `${minDays} a ${maxDays}` : minDays;
      return `${prefix} ${days} dias úteis`;
    }

    if (rate?.description) {
      return `${prefix} ${rate.description}`;
    }

    return `${prefix} ${this.dataset.deadlineUnavailable || "Prazo informado no checkout"}`;
  }

  _formatDate(value) {
    const parsed = new Date(`${value}T12:00:00`);
    if (Number.isNaN(parsed.getTime())) return value;

    try {
      return new Intl.DateTimeFormat(document.documentElement.lang || "pt-BR", {
        day: "2-digit",
        month: "2-digit"
      }).format(parsed);
    } catch (error) {
      return value;
    }
  }

  _formatPrice(rate) {
    const amount = Number(rate?.price);
    if (!Number.isFinite(amount)) return rate?.price || "";

    if (amount === 0) return this.dataset.freeLabel || "Grátis";

    const currency = rate?.currency || this.dataset.currency || "BRL";

    try {
      return new Intl.NumberFormat(document.documentElement.lang || "pt-BR", {
        style: "currency",
        currency
      }).format(amount);
    } catch (error) {
      return `${amount.toFixed(2)} ${currency}`;
    }
  }

  _getApiError(data) {
    const messages = [];

    const collect = (value) => {
      if (Array.isArray(value)) {
        value.forEach(collect);
      } else if (value && typeof value === "object") {
        Object.values(value).forEach(collect);
      } else if (value) {
        messages.push(String(value));
      }
    };

    collect(data?.errors || data);
    const message = messages.join(" ");
    if (/select a state/i.test(message)) {
      return "Não foi possível identificar o estado pelo CEP informado. Tente novamente.";
    }
    return message || this.dataset.errorMessage || "Não foi possível calcular o frete. Revise o CEP e tente novamente.";
  }
}

if (!customElements.get("ecomhard-shipping-rate-pdp")) {
  customElements.define("ecomhard-shipping-rate-pdp", EcomhardShippingRatePdp);
}

